export const introVideoRelativeLink = "/v-learn-to-code-by-doing-zilch";
export const buildingFirstBotVideoRelativeLink = "/v-programming-ping-pong";
